export const HEIGHT_SIZE = {
  small: 40,
  medium: 56,
  large: 72,
};

export const WIDTH_SIZE = {
  small: 128,
  medium: 176,
  large: 224,
};

export const PALLETE: Record<string, Record<string, string>> = {
  blue: {
    a: 'rgba(29, 148, 243, 1)',
  },
  white: {
    a: 'rgba(255, 255, 255, 1)',
  },
  red: {
    a: 'rgba(223, 74, 47, 1)',
  },
  orange: {
    a: 'rgba(223, 118, 47, 1)',
  },
};
